import { privateRequest, type ApiResponse } from "../axios";
import { saveAsExcelFile } from "../excelService/excelSevice";

export interface ILeaveRequest {
  UserName: string;
  EmployeeNo: string;
  ManagerName: string;
  CreateDate: string;
  LeaveType: string;
  ReasonForLeave: string;
  NumberOfDays: number;
  LeaveStartDate: string;
  LeaveEndDate: string;
  LeaveStatus: string;
  ReasonForRejection: string;
  LeaveTypeId: number;
  ActionBy: string | null;
  UserId: number;
  LeaveRequestId: number;
  FilePath: string | null;
  PendingActionBy: string | File | null;
  PendingApproverName: string | null;
  IsAllowApprove: boolean;
}

export interface ILeaveRequestsData {
  TotalRecords: number;
  Items: ILeaveRequest[];
}

const ENDPOINTS = {
  LEAVE_REQUESTS: "api/LeaveRequests",
  LEAVE_TYPES: "api/Leave/LeaveType",
  EXPORT_EXCEL: "api/Leaves/ExportToExcel",
  LEAVE_SETTINGS  :"api/GetLeaveSetting",
  APPROVE_REJECT : "api/LeaveRequests/Approvals",
  LEAVE_ATTACHMENT : "api/LeaveRequest/Attachment",
  LEAVE_HISTORY: "api/Leaves/{id}/History"
};

export const getLeaveRequests = async (data: any): Promise<ApiResponse<ILeaveRequestsData>> => {
  const res = await privateRequest.get<ApiResponse<ILeaveRequestsData>>(
    ENDPOINTS.LEAVE_REQUESTS,
    { params: data }
  );
  return res.data;
};

export const deleteLeaveRequest = async (
  leaveRequestId: number
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.LEAVE_REQUESTS}/${leaveRequestId}`
  );
  return res.data;
};

export const addLeaveRequest = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.LEAVE_REQUESTS,
    data
  );
  return res.data;
};

export const uploadLeaveAttachment = async (
  requestId: number,
  formData: FormData
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.LEAVE_ATTACHMENT}?requestId=${requestId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return res.data;
};

export const getLeaveTypes = async (): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.LEAVE_TYPES);
  return res.data;
};

const exportLeavesToExcel = async (data: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.EXPORT_EXCEL,data, { responseType: "arraybuffer" });
  return res;
};

const approveRejectLeave = async (data: {
  LeaveRequestId: number;
  Action: string;
  ReasonForRejection: string;
}): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.APPROVE_REJECT}`,
    data
  );
  return res.data;
};
const getLeaveHistory = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.LEAVE_HISTORY.replace("{id}", id.toString())
  );
  return res.data;
};

const leavesSettings = async() => {
  const res = await privateRequest.get(`${ENDPOINTS.LEAVE_SETTINGS}`);
  return res.data;
}

const LeaveRequestsService = {
  getLeaveRequests,
  deleteLeaveRequest,
  addLeaveRequest,
  uploadLeaveAttachment,
  getLeaveTypes,
  exportLeavesToExcel,
  approveRejectLeave,
  leavesSettings,
  getLeaveHistory
};

export default LeaveRequestsService;
